import React, { Component } from "react";
import { toastr } from "react-redux-toastr";
import Images from "../Assets/Images";
import Api from "../Services/Api";
import "../Styles/Login.scss";
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';

class ResetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      password: "",
      confirmPassword: "",
      pathUrl: this.props.location.state,
      PasswordVisibility:false,
      confirmPasswordVisibility:false,
    };
  }
  componentDidMount(){
    this.getValidUrl();
  }
  async getValidUrl() {
    debugger;
    try {
      this.setState({ ...this.state, loader: true });
      let params = {
        tenantKey: this.props.match.params.id,
        ForgotPasswordLink: this.props.match.params.token,
      };
      this.setState({ ...this.state, loader: true });
      let response = await Api.getValidUrl(params);
      if (response.status === 200) {
      }
      else
      {    
        if(this.state.pathUrl){
          this.props.history.push(this.state.pathUrl);
        }else{
          this.props.history.push("/");
        } 
        toastr.error("Invalid url.");
      }
    } catch (error) {
      this.setState({ ...this.state, loader: false });
      console.error(error);
    }
  };

  CheckPassword = (inputtxt) => {
    var paswd = /^(?=.*[0-9])(?=.*[!@#$%^&*])(?=.*[A-Z])[a-zA-Z0-9!@#$%^&*]{7,15}$/;
    if (inputtxt.match(paswd)) {
      return true;
    } else {
      return false;
    }
  };
  // a password between 8 to 15 characters which contain at least one lowercase letter, one uppercase letter, one numeric digit, and one special character
  Password = (e) => {
    this.setState({ password: e.target.value });
  };

  confirmPassword = (e) => {
    this.setState({ confirmPassword: e.target.value });
  };

  resetPassword = async (e) => {
    e.preventDefault();
    if (this.state.password !== "" && this.state.confirmPassword !== "") {
      if (
        this.CheckPassword(this.state.password) &&
        this.CheckPassword(this.state.confirmPassword)
      ) {
        if (this.state.password === this.state.confirmPassword) {
          let params = {
            password: this.state.password,
            tenantKey: this.props.match.params.id,
            ForgotPasswordLink: this.props.match.params.token,
          };
          let result = await Api.resetPasswordData(params);
          if (result) {
            if (result.status === 200) {
              this.setState({
                password: "",
                confirmPassword: "",
              });

              toastr.success(result.message);
              let tempPath = window.location.pathname;
              let userType = "";
              if (tempPath) {
                let res = tempPath.split("/");
                userType = res[1];
              } else {
                return;
              }
              if (result.LoggedClient === "Tenant" || userType) {
                userType = result.LoggedClient ? "tenant" : userType;
                this.props.history.push(
                  `/${userType}/${this.props.match.params.id}`
                );
              } else if (result.LoggedClient === "User" || userType) {
                userType = result.LoggedClient ? "user" : userType;
                this.props.history.push(
                  `/${userType}/${this.props.match.params.id}`
                );
              }
            } else {
              toastr.error(result.message);
            }
          }
        } else {
          toastr.error("Passwords are not matching");
        }
      } else {
        toastr.error(
          "Password should be 8-15 characters long with at least one lowercase letter, one uppercase letter, one numeric digit, and one special character"
        );
      }
    } else {
      toastr.error("Fields should not be empty");
    }
  };
  render() {
    return (
      <div className="auth-wrapper">
        <div className="auth-inner">
          <div className="authCont">
            <div className="logo">
              <img src={Images.RISKWELLLOGO} alt="Logo" width="200" />
            </div>
            <form name="form" onSubmit={this.handleSubmit}>
              <h4>Reset Password</h4>
              <div className="form-group">
                {/* <label>User Name</label> */}
                {/* <div className="ip-field">
                            <input type="email" name ="email" placeholder="Email Address" className="form-control" />
                            <span>
                                <img src={Images.MAIL} alt="Mail" width="17"/>
                            </span>
                        </div> */}
                {/* { this.submitted && !this.state.email &&
                            <div className="invalid-feedback">Email Address is required</div>
                        } */}
              </div>
              <div className="form-group">
                <div className="ip-field1">
                  <input
                    type={this.state.PasswordVisibility==true ?"text":"password"}
                    onChange={(e) => {
                      this.Password(e);
                    }}
                    value={this.state.password}
                    name="password"
                    placeholder="Password"
                    className="form-control"
                    pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,32}"
                  />
                  <span style={{cursor:'text',width:'17px'}}>
                    <img src={Images.PASSWORD} alt="User" width="17" />
                  </span>
                  <span  style={{display:"inline-block",right:"5px",position:"absolute"}}
                  onClick={()=>this.setState({PasswordVisibility:!this.state.PasswordVisibility})}>
                    {
                      this.state.PasswordVisibility?<VisibilityOutlinedIcon htmlColor="#005f62"/>:<VisibilityOffOutlinedIcon htmlColor="#005f62"/>
                    }
                  </span>
                </div>
                {/* { this.submitted && !this.state.password &&
                            <div className="invalid-feedback">Password is required</div>
                        } */}
              </div>
              <div className="form-group">
                <div className="ip-field1">
                  <input
                   type={this.state.confirmPasswordVisibility==true ?"text":"password"}
                    name="confirmPassword"
                    value={this.state.confirmPassword}
                    onChange={(e) => {
                      this.confirmPassword(e);
                    }}
                    placeholder="Confirm Password"
                    className="form-control"
                    pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,32}"
                  />
                  <span style={{cursor:'text',width:'17px'}}>
                    <img src={Images.PASSWORD} alt="User" width="17" />
                  </span>
                  <span  style={{display:"inline-block",right:"5px",position:"absolute"}}
                  onClick={()=>this.setState({confirmPasswordVisibility:!this.state.confirmPasswordVisibility})}>
                    {
                      this.state.confirmPasswordVisibility?<VisibilityOutlinedIcon htmlColor="#005f62"/>:<VisibilityOffOutlinedIcon htmlColor="#005f62"/>
                    }
                  </span>

                </div>
                {/* { this.statesubmitted && !this.state.confirmPassword &&
                            <div className="invalid-feedback">Confirm Password is required</div>
                        } */}
              </div>

              <button
                type="submit"
                onClick={(e) => this.resetPassword(e)}
                className="btn btn-primary btn-block btn-rounded relPosition"
              >
                Update
                {/* Spinner */}
                {/* <span className="MatBtnSpinner">
                                    <CircularProgress style={{'color': '#FFFFFF'}} size={22}/>
                                </span> */}
              </button>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default ResetPassword;
